<template>
  <m-button-theme-provider is="router-link" v-bind="props">
    <m-button-icon-container :loading="loading" :icon="icon" class="gap-1">
      <slot />
    </m-button-icon-container>
  </m-button-theme-provider>
</template>

<script lang="ts" setup>
  /**
   * Button themed  MRouterLink component.
   */
  import type { MButtonProps } from '@core/components/MButton';
  import type { MRouterLinkProps } from '@core/components/MLink';
  import MButtonThemeProvider from '@core/components/MButton/MButtonThemeProvider.vue';
  import MButtonIconContainer from '@core/components/MButton/MButtonIconContainer.vue';

  export interface MRouterLinkButtonProps extends Omit<MButtonProps, 'is'>, MRouterLinkProps {}

  const props = withDefaults(defineProps<MRouterLinkButtonProps>(), {
    rounded: true,
  });
</script>
